module.exports = __webpack_public_path__ + "static/img/sponsor.2a9c4da4.svg";